import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { Router } from "../node_modules/@slyte/router/index.js";
import  {ZcatComponentsMap}  from "./maps/map";
import {ZcatComponentsComponentRegistry}  from "../components/component";

class ZcatComponentsRouter extends Router {
    constructor() {
        super(...arguments);

        this.beforeRouteNavigation = function(prev,current) { 
            
        };

        this.afterRouteNavigation = function(current) {

        };
    }

    lookups(){
		return [{component : ZcatComponentsComponentRegistry}]
	}

    getComponentRegistry() {
		return this.$component;
	}

    getConfig() {
		var config = {
			baseMap : ZcatComponentsMap	
		}
		return config;
	}

    _() {
        _;
    }
}

export {ZcatComponentsRouter} ;

